import React, { type PropsWithChildren, useId } from 'react';
import styled from 'styled-components';

import { useRTL } from '../../../hooks/helpers/useRTL';
import { Text } from '../../atoms/text/Text';

type BorderedSectionProps = PropsWithChildren<{
	className?: string;
	testID: string;
	title?: string;
	titleInsideSection?: boolean;
}>;

export const BorderedSection = ({ children, className, testID, title, titleInsideSection }: BorderedSectionProps) => {
	const sectionID = useId();
	const { isRTL } = useRTL();
	const Title = titleInsideSection ? S.InlineTitle : S.Title;

	return (
		<S.Container aria-labelledby={sectionID} className={className} data-testid={testID}>
			<Title $isRTL={isRTL} id={sectionID} variant="text4">
				{title}
			</Title>
			{children}
		</S.Container>
	);
};

namespace S {
	export const Container = styled.div`
		position: relative;
		background-color: ${({ theme }) => theme.colors.backgrounds.main.container};
		${({ theme }) => theme.border.radius.medium};
		border-color: ${({ theme }) => theme.colors.borders.main.divider};
		border-style: ${({ theme }) => theme.borderStyles.divider.style};
		border-width: ${({ theme }) => theme.borderStyles.divider.width};
		padding: ${({ theme }) => theme.spacings.xsmall} ${({ theme }) => theme.spacings.small};
	`;

	export const Title = styled(Text)<{ $isRTL: boolean }>`
		background-color: ${({ theme }) => theme.colors.backgrounds.main.container};
		margin-bottom: ${({ theme }) => theme.spacings.xxsmall};
		text-align: ${({ $isRTL }) => ($isRTL ? 'right' : 'left')};
	`;

	export const InlineTitle = styled(Text)<{ $isRTL: boolean }>`
		background-color: ${({ theme }) => theme.colors.backgrounds.main.container};
		position: absolute;
		top: -${({ theme }) => theme.spacings.xxsmall};
		${({ $isRTL, theme }) => ($isRTL ? 'right: ' : 'left: ') + theme.spacings.xsmall};
		width: fit-content;
		padding: 0 ${({ theme }) => theme.spacings.xsmall};
	`;
}
